var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGameHistory = function SvgIconGameHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.092 4.386A20 20 0 1 1 9.857 38.14a2 2 0 0 1 2.83-2.828 16 16 0 1 0-4.662-12.168l.56-.56a2 2 0 1 1 2.829 2.829l-4 4a2 2 0 0 1-2.828 0l-4-4a2 2 0 1 1 2.828-2.828l.602.602A20 20 0 0 1 20.092 4.386M20 16a2 2 0 0 1 4 0v8h8a2 2 0 1 1 0 4H22a2 2 0 0 1-2-2z"
  })));
};
export default SvgIconGameHistory;